module.exports = __webpack_public_path__ + "static/media/Vector.bc2d462f.svg";